import { request as addValueRequest } from './reducers/add-value';
import { request as queryRequest } from './reducers/query';
import { request as editRequest } from './reducers/edit';

// eslint-disable-next-line import/no-default-export
export default {
    TAGS_ADD_VALUE_REQUEST: addValueRequest,
    TAGS_EDIT_REQUEST: editRequest,
    TAGS_QUERY_REQUEST: queryRequest,
};
